import React from "react";
import { connect } from "react-redux";
import { QuestionTableAdapter as Component } from "./QuestionTableAdapter";
import {
  questionTableCellChange,
  questionTableSubmit,
  questionTableShowHint,
  questionTableShowNextHint,
} from "./store/actions";
import TranslationsProvider from "../../TranslationsProvider";
import { fetchTranslations } from "../locales/config";

function mapStateToProps(state, ownProps) {
  const entry = state.questionTable[ownProps.id];

  if (!entry) {
    // If no matching entry is found, return the original ownProps.
    return ownProps;
  }

  const disabledList = entry.disabled || [];
  const totalAttempts = ownProps.totalAttempts - disabledList.length;
  const complete = entry.correct || totalAttempts === 0;
  const showHint = Object.prototype.hasOwnProperty.call(entry, "showHint")
    ? entry.showHint
    : false;

  const updatedData = () => {
    // First create a copy of the data object.
    const data = JSON.parse(JSON.stringify(ownProps.data));

    entry.data?.map(
      (overrideData) =>
        (data[overrideData.rowId][overrideData.colId] = {
          ...data[overrideData.rowId][overrideData.colId],
          ...overrideData.data, // override original data properties
        })
    );

    // Map over the question responses array and modify each item [rowId, colId] in the data to match the response values.
    entry.responses?.map((response) => {
      data[response.rowId][response.colId] = {
        ...data[response.rowId][response.colId],
        value: response.value,
        showFeedback: response.showFeedback,
        disabled: response.disabled,
        answer: response.answer,
        options: response.options,
      };
    });

    return data;
  };

  return {
    ...ownProps,
    data: updatedData(),
    totalAttempts: totalAttempts,
    submitDisabled: entry.submitDisabled,
    correct: entry.correct,
    complete: complete,
    showHint: showHint,
    hints: entry.hints,
    hintIndex: entry.hintIndex,
    responses: entry.responses || [],
  };
}

function mapDispatchToProps(dispatch) {
  return {
    onCellChange: (params) => {
      dispatch(questionTableCellChange(params));
    },
    // Dispatch the questionTableSubmit action.
    submitAnswer: (id) => {
      dispatch(questionTableSubmit(id));
    },
    // Dispatch the questionTableShowHint action.
    setShowHint: (params) => {
      dispatch(questionTableShowHint(params));
    },
    // Dispatch the questionTableShowNextHint action.
    showNextHint: (id) => {
      dispatch(questionTableShowNextHint(id));
    },
  };
}

export const QuestionTableRedux = connect(
  mapStateToProps,
  mapDispatchToProps
)((props) => (
  <TranslationsProvider fetchTranslations={fetchTranslations}>
    <Component {...props} />
  </TranslationsProvider>
));
